import { isbot } from 'isbot';
export function isBotUserAgent(userAgent) {
    if (!userAgent) {
        return false;
    }
    return isbot(userAgent);
}
export function isBotRequest(request) {
    return isBotUserAgent(request.headers.get('user-agent'));
}
